import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Header } from './Header';
import { Footer } from './Footer';
import { Button } from './ui/button';
import { Home, ArrowLeft } from 'lucide-react';

export const NotFoundPage = () => {
  const { t, language } = useLanguage();

  useEffect(() => {
    document.title = '404 - Page Not Found | NetGrid Host';
    // Set noindex for 404 pages
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'noindex, nofollow');
    window.scrollTo(0, 0);
  }, []);

  const isRu = language === 'ru';

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="flex items-center justify-center py-32">
        <div className="text-center max-w-lg mx-auto px-4">
          <div className="text-9xl font-bold text-blue-600 mb-4">404</div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            {isRu ? 'Страница не найдена' : 'Page Not Found'}
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            {isRu
              ? 'Запрашиваемая страница не существует или была перемещена.'
              : 'The page you are looking for does not exist or has been moved.'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => window.history.back()}
              className="bg-gray-100 text-gray-700 hover:bg-gray-200 font-semibold px-6 py-3"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              {isRu ? 'Назад' : 'Go Back'}
            </Button>
            <Button
              onClick={() => window.location.href = isRu ? '/ru' : '/'}
              className="bg-blue-600 text-white hover:bg-blue-700 font-semibold px-6 py-3"
            >
              <Home className="w-4 h-4 mr-2" />
              {isRu ? 'На главную' : 'Home Page'}
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
